if (!customElements.get('black-sea')) {
  customElements.define(
    'black-sea',
    class BlackSea extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const canvas = this.querySelector('canvas');
        const ctx = canvas.getContext('2d');

        let width, height, points;
        const ROWS = 250;
        const COLS = 500;
        const SPACING = 24;

        const init = () => {
          width = canvas.width = window.innerWidth;
          height = canvas.height = window.innerHeight;
          points = [];

          for (let iz = -20; iz < ROWS; iz++) {
            for (let ix = 0; ix < COLS; ix++) {
              points.push({
                x: ix * SPACING - (COLS * SPACING) / 2,
                y: 900, // Vertical "floor" level
                z: iz * SPACING
              });
            }
          }
        };

        let count = 0;

        const render = () => {
          ctx.fillStyle = '#000';
          ctx.fillRect(0, 0, width, height);

          const centerX = width / 2;
          const centerY = height / 2;

          points.forEach(p => {
            const yOffset = (
              Math.sin((p.x * 0.01) + count) +
              Math.sin((p.z * 0.02) + count) +
              Math.sin((p.x * 0.02 + p.z * 0.01) + count * 0.5)
            ) * 15;

            const focalLength = 600;
            const scale = focalLength / (focalLength + p.z);

            const x2d = p.x * scale + centerX;
            // const y2d = (p.y + yOffset) * scale + centerY;
            const y2d = (p.y + yOffset) * scale + (height * 0.3);

            const opacity = Math.min(1, Math.max(0, 1.5 - p.z / 800));
            const size = Math.max(0.5, 1.5 * scale);

            if (opacity > 0) {
              const brightness = 150 + (yOffset * 5);
              ctx.fillStyle = `rgba(${brightness}, ${brightness}, ${brightness}, ${opacity})`;

              ctx.beginPath();
              ctx.arc(x2d, y2d, size, 0, Math.PI * 2);
              ctx.fill();
            }
          });

          count += 0.03;
          requestAnimationFrame(render);
        };

        window.addEventListener('resize', init);
        init();
        render();
      }
    }
  )
}

